import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Avatar,
  Badge,
  List,
} from 'antd';
import i18n from '../../config/i18n';
import '../../styles/css/channelListItem.css';

const formatTime = (date) => {
  const targetTime = moment(date);
  const currentTime = moment();
  if (targetTime.isSame(currentTime, 'day')) {
    return targetTime.format('hh:mm');
  }
  if (targetTime.isSame(currentTime.subtract(1, 'days'), 'day')) {
    return i18n.t('yesterday');
  }
  if (targetTime.isSame(currentTime, 'week')) {
    return targetTime.format('dddd');
  }
  if (targetTime.isSame(currentTime, 'year')) {
    return targetTime.format('MM/DD');
  }
  return targetTime.format('YYYY/MM/DD');
};


const ChannelListItem = ({
  channel,
  onClick,
  selected,
  highlight,
}) => (
  <List.Item
    className={`channel-list-item ${selected ? 'selected' : ''} ${highlight ? 'highlight' : ''}`}
    key={channel.id}
    onClick={() => onClick(channel.id)}
    extra={
      <div className="channel-list-item-detail">
        {formatTime(channel.lastMsg.createdAt)}
        <Badge
          className="channel-list-item-unread-count"
          count={channel.unReadCnt}
        />
      </div>
    }
  >
    <List.Item.Meta
      className="channel-list-item-meta"
      avatar={
        <Avatar
          icon="message"
          size={40}
          src={channel.avatar}
        />
      }
      title={channel.displayName}
      description={channel.lastMsg.text}
    />
  </List.Item>
);

ChannelListItem.propTypes = {
  channel: PropTypes.shape({
    id: PropTypes.number.isRequired,
    unReadCnt: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    lastMsg: PropTypes.shape({
      createdAt: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  highlight: PropTypes.bool,
};

ChannelListItem.defaultProps = {
  selected: false,
  highlight: false,
};


export default ChannelListItem;



// WEBPACK FOOTER //
// ./src/components/messaging/ChannelListItem.js